import React from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'components/input/DateRange/DateRangePicker';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { Field } from 'redux-form';

const DateRangeFilter = (props) => {
    const {
        floatingLabelFixed,
        label,
        placeholder,
        source,
        translate,
    } = props;

    return (
        <Field
            name={ `${ source }[value]` }
            component={ ({ input }) => {
                // First we will transform the string into an array of values.
                if (utils.isString(input.value)) {
                    const [
                        first,
                        second,
                    ] = input.value.split('~').map(function (val) {
                        return val;
                    });

                    input.value = [
                        first || null,
                        second || null,
                    ];
                }

                if (utils.isArray(input.value)) {
                    utils.map(input.value, (val) => {
                        if (utils.isDate(val)) {
                            return val;
                        }

                        return new Date(val);
                    });
                }

                return (
                    <DateRangePicker
                        { ...input }
                        { ...props }
                        floatingLabelFixed={ floatingLabelFixed }
                        fullWidth={ true }
                        hintText={ placeholder ? translate(placeholder) : null }
                        floatingLabelText={ label ? translate(label) : null }
                        onAccept={ (...values) => {
                            const newValues = values.map((date) => {
                                return date.toISOString();
                            });

                            return input.onChange(newValues);
                        } }
                    />
                );
            } }
        />
    );
};

DateRangeFilter.propTypes = {
    floatingLabelFixed: true,
};

DateRangeFilter.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(DateRangeFilter);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/DateRangeFilter.js